import styled from 'styled-components';
import {
  ButtonBase,
  PrimaryLink,
  BaseColumnWrap,
} from '../../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';
export const PaxDetailsDiv = styled.div(
  props => `
    width:80%;
    display:flex;
    justify-content:space-between;
    align-items:center
    padding-right:${props.theme.spacing.base};
    `,
);

export const PricingWrapper = styled(BaseColumnWrap)(
  props => `
    align-items:flex-end;
    `,
);

export const StrickedpriceSpan = styled.span(
  props => `
    text-decoration: line-through;
    color: ${props.theme.colors.downriver.medium};
  `,
);

export const OriginalpriceSpan = styled.span`
  ${textSizes.BaseW3}
`;

export const TaxpriceSpan = styled.span(
  props => `
    color: ${props.theme.colors.downriver.medium};
  `,
);

export const PaxAdditionDiv = styled.div(
  props => `
    width:20%;
    margin-left:10px;
    `,
);
